/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Superclinical's own vocabulary, deliberately not the FHIR `QuestionnaireItemType` value set.
 */
export type QuestionControl =
  (typeof QuestionControl)[keyof typeof QuestionControl];

export const QuestionControl = {
  single_choice: "single_choice",
  multi_choice: "multi_choice",
  text: "text",
  number: "number",
  quantity: "quantity",
  boolean: "boolean",
  date: "date",
  datetime: "datetime",
  time: "time",
  display: "display",
} as const;
